import { LazyLoad } from '@petconsole/pure-fe-mui';

const DogParkAdmin = LazyLoad(() => import('./DogParkAdmin'));

export { DogParkAdmin };
